/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import { cid, container } from 'inversify-props';
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import { paths } from './routes'


function mapRoute(path) {
  var routes = []

  var route = {
    name: path.name || path.view,
    path: path.path || '',
    props: path.props,
    meta: path.meta || {},
    title: path.title,
    beforeEnter: requireAuth
  }


  if (path.view) {
    route.component = (resovle) => import(
      `@views/${path.view}.vue`
    ).then(resovle)
  }

  routes.push(route)

  if (path.children && path.children.length > 0) {

    for (var i = 0; i < path.children.length; i++) {
      var childRoutes = mapRoute(path.children[i])
      routes = routes.concat(childRoutes)
    }
  }

  return routes
}

function requireAuth(to, from, next) {
  // Used for callbacks etc.
  if (to.meta.skipAuthCheck) {
    next();
  } else {
    handleAuth(from, to, next);
  }
}

function handleAuth(from, to, next) {
  const authService = container.get(cid.IAuthService);
  authService.userHasToken().then(response => {
    if (response) {
      if (!to.meta.role) {
        // A role is not defined for the route, but the user is authorized.
        next();
      }
      else {
        authService.userHasRole(to.meta.role).then(hasRoleForToRoute => {
          // if user doesn't have required role for the to route
          if (!hasRoleForToRoute) {
            authService.userHasRole(from.meta.role).then(hasRoleForFromRoute => {
              // if user doesn't have required role for the from route
              if ((!from?.name || !hasRoleForFromRoute)) {
                window.location = '/';
              } else
              // if user has required role for the from route
              {
                window.location = from.path;
              }
            });
          } else
          // if user has required role for the to route
          {
            next();
          }
        });
      }
    } else {
      authService.clearUserAndRedirectToLogin();
    }
  }, error => {
    console.error(error);
  });
}

Vue.use(Router)

var routes = []

paths.forEach(path => {
  routes = routes.concat(mapRoute(path))
})

// Create a new router
const router = new Router({
  mode: 'history',
  routes: routes.concat([
    { path: '*', redirect: '/dashboard' }
  ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
